module.exports = __webpack_public_path__ + "static/media/bike2go.039617c0.png";